'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHdrOff = function MdHdrOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm4.1 4.1c10.6 10.7 21.3 21.2 31.9 31.8l-1.9 1.8-12.6-12.7h-5.6v-5.7l-2.5-2.5v8.2h-2.5v-4.1h-3.4v4.1h-2.5v-10h2.5v3.4h3.4v-3.4h0.6l-9.2-9.1z m17.5 13.4h-0.6l-2.5-2.5h3.1c1.4 0 2.5 1.2 2.5 2.5v3.2l-2.5-2.5v-0.7z m7.5 0v1.6h3.4v-1.6h-3.4z m0 7.5h-0.6l-1.9-1.8v-8.2h5.9c1.3 0 2.5 1.2 2.5 2.5v1.6c0 1.1-0.6 2.1-1.5 2.4l1.5 3.5h-2.5l-1.5-3.4h-1.9v3.4z' })
        )
    );
};

exports.default = MdHdrOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/hdr-off.js
// module id = 2927
// module chunks = 0